import { gsap, MotionPathPlugin } from 'gsap/all';
import { useEffect } from 'react';

/**
 * For when we have an object that should follow a path. Tied to the user's scroll position.
 * @param {*} props
 * @returns
 */

function Key5Mobile({ animate }) {
   gsap.registerPlugin(MotionPathPlugin);

   useEffect(() => {
      const pathElem = document.querySelector('#path5mobile');
      const offsetFromTop = window.innerHeight * 0.3;
      const pathBB = pathElem.getBoundingClientRect();
      const startY = pathBB.top + window.scrollY - offsetFromTop;
      // const startY = document.querySelector("#path1").offsetTop - window.innerHeight + offsetFromTop;
      const finishDistance = 300;

      const tween = gsap.to('#key5mobile', {
         duration: 50,
         paused: true,
         progress: 0.5,
         repeat: 0,
         reverse: true,
         keyframes: [
            {
               motionPath: {
                  path: '#path5mobile',
                  align: '#path5mobile',
                  alignOrigin: [0.3, 0.2],
                  autoRotate: 0,
                  start: 0.1,
               },
            },
         ],
         ease: 'none',
      });

      let requestId = null;
      // document.addEventListener("scroll", handleScroll);

      if (animate) {
         document.addEventListener('scroll', handleScroll);
         tween.progress((window.scrollY - startY) / finishDistance);
      } else {
         tween.progress(0.5);
         tween.pause();
         document.removeEventListener('scroll', handleScroll);
      }

      function handleScroll() {
         if (!requestId) {
            requestId = requestAnimationFrame(update);
         }
      }

      function update() {
         // Update our animation

         if (animate) {
            tween.progress((window.scrollY - startY) / finishDistance);
         } else {
            tween.progress(0.5);
            tween.pause();
         }
         // Let the scroll event fire again
         requestId = null;
      }
      return () => document.removeEventListener('scroll', handleScroll);
   }, [animate]);
   return (
      <div className="pathcontainer key5mobile-container">
         <svg
            className="key5mobile"
            xmlns="http://www.w3.org/2000/svg"
            width="523.045"
            height="285.186"
         >
            <image
               id="key5mobile"
               href="/ReactAssets/CustomerJourney/keypaths/desktop/Key.svg"
               width="80"
               height="80"
               data-svg-origin="24 12"
               transform={
                  animate
                     ? 'matrix(0.72871,0.68482,-0.68482,0.72871,29.08149,27.09543)'
                     : 'matrix(0.99302,0.11796,-0.11796,0.99302,156.85329,91.20042)'
               }
            />
            <path
               opacity="0.999"
               stroke-dasharray="10 14"
               stroke-width="2"
               stroke-linecap="round"
               stroke="#a39161"
               fill="none"
               d="m1.26208,1.26296c33.477,101.781 168.747,113.2 266.406,113.2s234.079,31.849 254.241,169.589"
               data-name="Path 5"
               id="path5mobile"
            />
         </svg>
      </div>
   );
}

export default Key5Mobile;
